import { useCallback, useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { PlanLoadingErrorModalContent } from './planLoadingErrorModalContent/PlanLoadingErrorModalContent'

interface IProps {
  translations?: { title: string; text: string; close: string }
  isOpen: boolean
  onClose: () => void
}

export const PlanLoadingErrorModal = ({ isOpen, onClose, translations }: IProps) => {
  const onCloseDialog = useCallback(() => {
    onClose()
  }, [onClose])

  const contentProps = useMemo(() => {
    return {
      onClose,
      translations,
    }
  }, [onClose, translations])

  return (
    <ModalDialog
      show={isOpen}
      size={'xs'}
      onClose={onCloseDialog}
      content={PlanLoadingErrorModalContent}
      contentProps={contentProps}
    />
  )
}
